import styled from 'styled-components';

export const Box = styled.div`
background-color: #ebf5f5;
color: #3e4040;
margin: 1.2vw auto;
padding:1vw;
height: 25vw;
width: 50vw;
border-radius: 2vw;
text-align: center;

`